<template>
  <v-menu :close-on-content-click="false" bottom min-width="200px" offset-y rounded>
    <template v-slot:activator="{ on }">
      <v-btn icon x-large v-on="on">
        <v-avatar color="primary" size="40">
          <span class="white--text text-h6">{{ gebruikerInfoService.initialen }}</span>
        </v-avatar>
      </v-btn>
    </template>
    <v-card>
      <v-list-item-content class="justify-center">
        <div class="mx-auto text-center">
          <v-avatar color="primary">
            <span class="white--text text-h5">{{ gebruikerInfoService.initialen }}</span>
          </v-avatar>
          <h3>{{ gebruikerInfoService.volledigeNaam }}</h3>
          <v-divider class="my-3" />

          <template v-if="!gebruikerInfoService.controleur && gebruikerInfoService.erkenningsnummer">
            {{ gebruikerInfoService.erkenningsnummer }}
            <v-divider class="my-3" />
          </template>
          <template
            v-if="
              !gebruikerInfoService.controleur &&
              (gebruikerInfoService.geschorstDeskD || gebruikerInfoService.ingetrokkenDeskD)
            "
          >
            {{
              gebruikerInfoService.geschorstDeskD
                ? $t('algemeen.erkenning-info.status.geschorst')
                : $t('algemeen.erkenning-info.status.ingetrokken')
            }}
            <info-tooltip>
              <v-card>
                <v-card-text style="color: black">
                  {{
                    $t('algemeen.erkenning-info.information', {
                      status: (gebruikerInfoService.geschorstDeskD
                        ? $t('algemeen.erkenning-info.status.geschorst')
                        : $t('algemeen.erkenning-info.status.ingetrokken')
                      )
                        .toString()
                        .toLowerCase(),
                    })
                  }}
                </v-card-text>
              </v-card>
            </info-tooltip>
            <v-divider class="my-3" />
          </template>

          <template v-if="!gebruikerInfoService.controleur && gebruikerInfoService.ondernemingInfo">
            {{ gebruikerInfoService.ondernemingInfo }}
            <v-divider class="my-3" />
          </template>

          <template v-if="!gebruikerInfoService.controleur && gebruikerInfoService.registratierollen">
            {{ gebruikerInfoService.registratierollen }}
            <v-divider class="my-3" />
          </template>

          <v-btn depressed rounded @click="switchen">{{ $t('links.switchen') }}</v-btn>
          <v-divider class="my-3" />
          <v-btn depressed rounded @click="afmelden">{{ $t('links.afmelden') }}</v-btn>
        </div>
      </v-list-item-content>
    </v-card>
  </v-menu>
</template>

<script lang="ts">
import { Component, Inject, Vue } from 'vue-property-decorator';
import InfoTooltip from '@/components/dialog/InfoTooltip.vue';
import GebruikerInfoService from '@/services/GebruikerInfoService';

@Component({
  components: { InfoTooltip },
})
export default class ProfileDropdown extends Vue {
  @Inject('gebruikerInfoService') gebruikerInfoService: GebruikerInfoService;

  afmelden() {
    this.$router.push('/afmelden');
  }

  switchen() {
    this.$router.push('/wisselen');
  }
}
</script>
